export function normalizeLtMonth(str: string) {
  return str
    .toLowerCase()
    .normalize('NFD')
    .replace(/ž/g, 'z').replace(/š/g, 's').replace(/č/g, 'c')
    .replace(/ė/g, 'e').replace(/ų/g, 'u').replace(/ū/g, 'u')
    .replace(/ą/g, 'a').replace(/į/g, 'i').replace(/ę/g, 'e')
    .replace(/[\u0300-\u036f]/g, ''); 
}
export const ltMonths = [
  'Sausis',
  'Vasaris',
  'Kovas',
  'Balandis',
  'Gegužė',
  'Birželis',
  'Liepa',
  'Rugpjūtis',
  'Rugsėjis',
  'Spalis',
  'Lapkritis',
  'Gruodis',
];

export const ltMonthsNormalized = ltMonths.map(m => normalizeLtMonth(m));

export const weekdaysLt = ['Pr', 'An', 'Tr', 'Kt', 'Pn', 'Št', 'Sk'];